import React from 'react';
import { Tooltip } from 'antd';
import Icon from '@ant-design/icons';

import LockSvg from 'icons/home/lock.svg';
import { PermissionFlagWrapper } from './styled';
import { useCreatePermissions } from '@hooks/usePermissions';

const PermissionFlag = () => {
  const hasCreate = useCreatePermissions();

  if (hasCreate) return null;

  return (
    <Tooltip title="Non-Admin Permission, Please contact your Conviva representative to activate.">
      <PermissionFlagWrapper>
        <Icon component={LockSvg} />
        <span>Non-Admin Permission</span>
      </PermissionFlagWrapper>
    </Tooltip>
  );
};

export default PermissionFlag;
